import * as React from 'react';
import { clsx } from 'clsx';
import { UIHeading4, UIText2 } from '@cian/ui-kit';

import { ESalesType, ISalesLink } from '../../../../types/offersData';
import { getDescriptionColor, getTitleColor } from './utils';

import * as styles from './SalesLink.css';

interface ISalesLinkProps {
  link: ISalesLink;
  onClick(link: ISalesLink): void;
}

const SALES_TYPE_CLASSES = new Map<ESalesType, string>([
  [ESalesType.BlackFriday, styles['black-friday']],
  [ESalesType.ConsultantPage, styles['consultant']],
  [ESalesType.PromoIndexPage, styles['newbuilding-promo']],
  [ESalesType.SalesLeader, styles['sales-leader']],
  [ESalesType.SalesStart, styles['sales-start']],
  [ESalesType.UpcomingSale, styles['sales-soon']],
]);

export function SalesLink({ link, onClick }: ISalesLinkProps) {
  const { salesType } = link;

  const salesTypeClassName = SALES_TYPE_CLASSES.get(salesType);
  const titleColor = getTitleColor(salesType);
  const descriptionColor = getDescriptionColor(salesType);

  const handleClick = React.useCallback(() => {
    onClick(link);
  }, [onClick, link]);

  return (
    <a className={clsx(styles['link'], salesTypeClassName)} href={link.url} onClick={handleClick}>
      <div className={styles['content']}>
        <UIHeading4 as="h4" color={titleColor}>
          {link.title}
        </UIHeading4>
        <UIText2 color={descriptionColor}>{link.text}</UIText2>
      </div>
    </a>
  );
}
